import { send } from '../../../src/network/network';
import { type SignupResponse } from '../../v2/auth/signup/post/post-api-v2-auth-signup';

type Params = {
  code: string;
  idToken: string;
  isWeb: true;
  state: string;
  /**
   * Marks a freemium (guest-flow) signup when this login creates an account.
   * Sent only when true so a standard login/signup payload is unchanged.
   */
  isGuestFlow?: boolean;
};

type AppleLoginResponse = {
  created: boolean;
  customer: SignupResponse;
};

export function postAppleLogin(params: Params) {
  return send<AppleLoginResponse>({
    path: '/api/apple_login/',
    method: 'POST',
    body: {
      code: params.code,
      id_token: params.idToken,
      state: params.state,
      is_web: params.isWeb,
      // Form-encoded, so the backend reads the string through `is_param_truthy`.
      ...(params.isGuestFlow === true ? { is_guest_flow: 'true' } : {}),
    },
    headers: new Headers({
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    }),
  });
}
